import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BackToTop from './BackToTop';
import ClientProvider from './client';
export default createDemo(import.meta.url, BackToTop, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/app-bar/demos/back-to-top/BackToTop.tsx",
    "fileName": "BackToTop.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\nimport Fab from '@mui/material/Fab';\nimport KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';\nimport Fade from '@mui/material/Fade';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<unknown>;\n}\n\nfunction ScrollTop(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    target: window ? window() : undefined,\n    disableHysteresis: true,\n    threshold: 100,\n  });\n\n  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {\n    const anchor = (\n      (event.target as HTMLDivElement).ownerDocument || document\n    ).querySelector('#back-to-top-anchor');\n\n    if (anchor) {\n      anchor.scrollIntoView({\n        block: 'center',\n      });\n    }\n  };\n\n  return (\n    <Fade in={trigger}>\n      <Box\n        onClick={handleClick}\n        role=\"presentation\"\n        sx={{ position: 'fixed', bottom: 16, right: 16 }}\n      >\n        {children}\n      </Box>\n    </Fade>\n  );\n}\n\nexport default function BackToTop(props: Props) {\n  return (\n    <React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <CssBaseline />\n      <AppBar>\n        <Toolbar>\n          <Typography variant=\"h6\" component=\"div\">\n            Scroll to see button\n          </Typography>\n        </Toolbar>\n      </AppBar>\n      <Toolbar id=\"back-to-top-anchor\" />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n      <ScrollTop {...props}>\n        <Fab size=\"small\" aria-label=\"scroll back to top\">\n          <KeyboardArrowUpIcon />\n        </Fab>\n      </ScrollTop>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </React.Fragment>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 89,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\nimport Fab from '@mui/material/Fab';\nimport KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';\nimport Fade from '@mui/material/Fade';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<unknown>;\n}\n\nfunction ScrollTop(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    target: window ? window() : undefined,\n    disableHysteresis: true,\n    threshold: 100,\n  });\n\n  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {\n    const anchor = (\n      (event.target as HTMLDivElement).ownerDocument || document\n    ).querySelector('#back-to-top-anchor');\n\n    if (anchor) {\n      anchor.scrollIntoView({\n        block: 'center',\n      });\n    }\n  };\n\n  return (\n    <Fade in={trigger}>\n      <Box\n        onClick={handleClick}\n        role=\"presentation\"\n        sx={{ position: 'fixed', bottom: 16, right: 16 }}\n      >\n        {children}\n      </Box>\n    </Fade>\n  );\n}\n\nexport default function BackToTop(props: Props) {\n  return (\n    <React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "      <CssBaseline />\n      <AppBar>\n        <Toolbar>\n          <Typography variant=\"h6\" component=\"div\">\n            Scroll to see button\n          </Typography>\n        </Toolbar>\n      </AppBar>\n      <Toolbar id=\"back-to-top-anchor\" />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n      <ScrollTop {...props}>\n        <Fab size=\"small\" aria-label=\"scroll back to top\">\n          <KeyboardArrowUpIcon />\n        </Fab>\n      </ScrollTop>\n"
      ],
      [
        "span",
        "frame",
        "    </React.Fragment>\n  );\n}\n"
      ]
    ],
    "totalLines": 89,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/AppBar",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/CssBaseline",
      "@mui/material/useScrollTrigger",
      "@mui/material/Box",
      "@mui/material/Container",
      "@mui/material/Fab",
      "@mui/icons-material/KeyboardArrowUp",
      "@mui/material/Fade"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
